import { api } from './authService';

const googleAuthService = {
  /**
   * Get Google OAuth authorization URL
   * @returns {Promise<string>} - Authorization URL
   */
  getAuthUrl: async () => {
    try {
      const response = await api.get('/auth/google');
      return response.data.url;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get Google authorization URL');
    }
  },

  /**
   * Initiate Google OAuth login
   */
  loginWithGoogle: async () => {
    try {
      const authUrl = await googleAuthService.getAuthUrl();
      window.location.href = authUrl;
    } catch (error) {
      console.error('Google login error:', error);
      throw error;
    }
  },

  /**
   * Handle Google OAuth callback response
   * This is now handled by the AuthCallback component
   */
  handleCallback: () => {
    // This method is deprecated - callback handling is now done in AuthCallback component
    return null;
  }
};

export default googleAuthService;
